import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

interface Props {
  matterId: string;
  subsetId: string;
  caseName: string;
}

interface DownloadZipResponse {
  downloadUrl: string;
}

export const useDownloadDocumentZip = ({ matterId, subsetId, caseName }: Props) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const downloadDocumentZip = async (exportId: string): Promise<void> => {
    const response = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/docs/download-zip/${subsetId}?exportId=${exportId}`,
      fetchConfigGET,
    );

    if (!response.ok) {
      throw new Error('Failed to get zip download URL');
    }

    const data: DownloadZipResponse = await response.json();

    const link = Object.assign(document.createElement('a'), {
      href: data.downloadUrl,
      download: `${caseName}.zip`,
    });

    link.click();
  };

  const { mutate: downloadZip, isLoading: isDownloadingZip, error } = useMutation(downloadDocumentZip);

  return { downloadZip, isDownloadingZip, error };
};
